import settings from "../../configs/appSettings";

export const imageCdnUrls = {
    //illustrations
    assessmentHistory: `${settings.cdnUrl}/illustrations/assessment-history.svg`,
    completeMilestone: `${settings.cdnUrl}/illustrations/complete-milestone.svg`,       // ribbon
    completeInitiative: `${settings.cdnUrl}/illustrations/complete-initiative.svg`,     // check mark
    emptyCalendar: `${settings.cdnUrl}/illustrations/empty-calendar.svg`,
    incompletePuzzle: `${settings.cdnUrl}/illustrations/incomplete-puzzle.svg`,         // puzzle pieces
    milestone: `${settings.cdnUrl}/illustrations/milestone.svg`,                        // mountain with flag
    newUser: `${settings.cdnUrl}/illustrations/new-user.svg`,
    noDataAvailable: `${settings.cdnUrl}/illustrations/no-data-available.svg`,
    noLinked: `${settings.cdnUrl}/illustrations/no-linked.svg`,
    noSearchResults: `${settings.cdnUrl}/illustrations/no-search-results.svg`,          // magnifying glass
    noItemsSelected: `${settings.cdnUrl}/illustrations/no-items-selected.svg`,
    notification: `${settings.cdnUrl}/illustrations/notification.svg`,                  // bell
    noTimeline: `${settings.cdnUrl}/illustrations/no-timeline.svg`,
    plannedInitiative: `${settings.cdnUrl}/illustrations/planned-initiative.svg`,
    strategicInitiative: `${settings.cdnUrl}/illustrations/strategic-initiative.svg`,
    tableEmpty: `${settings.cdnUrl}/illustrations/table-empty.svg`,
    xError: `${settings.cdnUrl}/illustrations/x-error.svg`,
    questionChecklist: `${settings.cdnUrl}/illustrations/question-checklist.svg`,
    audit: `${settings.cdnUrl}/illustrations/audit.svg`,
    reviewNote: `${settings.cdnUrl}/illustrations/review-note.svg`,
    arrow: `${settings.cdnUrlIcons}/arrow.svg`,

    //icons
    addDocument: `${settings.cdnUrl}/icons/Add-Document.svg`,
    addDocumentCount: `${settings.cdnUrl}/icons/Add-Document-Count.svg`,
    assessmentList: `${settings.cdnUrl}/icons/assessment-list.svg`,
    attachment: `${settings.cdnUrl}/icons/attachment.svg`,
    appSwitcher: `${settings.cdnUrl}/icons/app-switcher.svg`,
    backArrow: `${settings.cdnUrl}/icons/back-arrow.svg`,
    binoculars: `${settings.cdnUrl}/icons/binoculars.svg`,
    binocularsPastDue: `${settings.cdnUrl}/icons/binoculars-past-due.svg`,
    blueX: `${settings.cdnUrl}/icons/x-blue.svg`,
    nextArrow: `${settings.cdnUrl}/icons/arrow-next.svg`,
    calendarYear: `${settings.cdnUrl}/icons/cal-year.svg`,
    caretDownWhite: `${settings.cdnUrl}/icons/caret-down-white.svg`,
    caretRightWhite: `${settings.cdnUrl}/icons/caret-right-white.svg`,
    caretDownGrey: `${settings.cdnUrl}/icons/caret-down-grey.svg`,
    caretUpGrey: `${settings.cdnUrl}/icons/caret-up-grey.svg`,
    checkboxSelected: `${settings.cdnUrl}/icons/checkbox-selected.svg`,
    checkboxSelectedGrey: `${settings.cdnUrl}/icons/checkbox-selected-grey.svg`,
    checkboxSelectedGreen: `${settings.cdnUrl}/icons/checkbox-selected-green.svg`,
    checkboxUnselected: `${settings.cdnUrl}/icons/checkbox-unselected.svg`,
    checkmark: `${settings.cdnUrl}/icons/checkmark.svg`,
    checkmarkGrayOutline: `${settings.cdnUrl}/icons/check-gray-outline.svg`,
    checkmarkBlue: `${settings.cdnUrl}/icons/checkmark-blue.svg`,
    checkmarkCircle: `${settings.cdnUrl}/icons/checkmark-circle.svg`,
    controls: `${settings.cdnUrl}/icons/controls.svg`,
    controlsAdd: `${settings.cdnUrl}/icons/control-add.svg`,
    controlsNone: `${settings.cdnUrl}/icons/controls-none.svg`,
    datePicker: `${settings.cdnUrl}/icons/date-picker.svg`,
    dashboard: `${settings.cdnUrl}/icons/dashboard.svg`,
    download: `${settings.cdnUrl}/icons/download.svg`,
    document: `${settings.cdnUrl}/icons/document.svg`,
    documentRed: `${settings.cdnUrl}/icons/document-red.svg`,
    documentStack: `${settings.cdnUrl}/icons/document-stack.svg`,
    exclamation: `${settings.cdnUrl}/icons/exclamation-circle.svg`,
    exclamationRed: `${settings.cdnUrl}/icons/Red-Exclamation.svg`,
    filter: `${settings.cdnUrl}/icons/filter.svg`,
    greyX: `${settings.cdnUrl}/icons/x-grey.svg`,
    helpSupport: `${settings.cdnUrl}/icons/help-support.svg`,
    info: `${settings.cdnUrl}/icons/info.svg`,
    key: `${settings.cdnUrl}/icons/key.svg`,
    redX: `${settings.cdnUrl}/icons/x-red.svg`,
    threeDots: `${settings.cdnUrl}/icons/3-dots.svg`,
    whiteX: `${settings.cdnUrl}/icons/x-white.svg`,
    startDate: `${settings.cdnUrl}/icons/start-date.svg`,
    seeNote: `${settings.cdnUrl}/icons/see-note.svg`,
    dueDate: `${settings.cdnUrl}/icons/due-date.svg`,
    retry: `${settings.cdnUrl}/icons/retry.svg`,
    selectedFlag: `${settings.cdnUrl}/icons/Flag - Selected.svg`,
    unselectedFlag: `${settings.cdnUrl}/icons/Flag - Unselected.svg`,
    viewNotes: `${settings.cdnUrl}/icons/view-notes.svg`,
    addNote: `${settings.cdnUrl}/icons/add-note.svg`,
    comments: `${settings.cdnUrl}/icons/comment.svg`,
    trashCan: `${settings.cdnUrl}/icons/trash-can.svg`,
    target: `${settings.cdnUrl}/icons/target.svg`,
    users: `${settings.cdnUrl}/icons/users.svg`,
    singleUser: `${settings.cdnUrl}/icons/user-solid.svg`,
    legend: `${settings.cdnUrl}/icons/legend.svg`,
    reports: `${settings.cdnUrl}/icons/reports.svg`,
    audits: `${settings.cdnUrl}/icons/audits.svg`,
    auditBehindSchedule: `${settings.cdnUrl}/icons/audit-behind-schedule.svg`,
    reportSubmitted: `${settings.cdnUrl}/icons/report-submitted.svg`,
    questionMarkCircle: `${settings.cdnUrl}/icons/question-mark-circle.svg`,

    //logos
    nLogoBlue: `${settings.cdnUrl}/logos/logo-blue.svg`,
    nLogoGrey: `${settings.cdnUrl}/logos/logo-grey.svg`,
    nLogoWhite: `${settings.cdnUrl}/logos/logo-white.svg`,
    nLogoSettings: `${settings.cdnUrl}/logos/nsettings.svg`,
    nLogoVerify: `${settings.cdnUrl}/logos/logo-nverify.svg`,

    //animations
    smallLoader: `${settings.cdnUrl}/loading-animations/small-loader.gif`,

    //gifs
    generatingReport: `${settings.cdnUrl}/gifs/generating-report.gif`,
};
